import { privateInstance } from "../configs";
import moment from "moment";

let baseUrl = "/analytics/api/";

export const analyticApi = {
  async getSalesAnalytics(params) {
    let url = baseUrl + "sales/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.store && params.store.length > 0) {
        paramsArray.push(`stores=${params.store.join(",")}`);
      }
      if (params.start) {
        paramsArray.push(`start=${moment(params.start).format("YYYY-MM-DD")}`);
      }
      if (params.end) {
        paramsArray.push(`end=${moment(params.end).format("YYYY-MM-DD")}`);
      }

      url += paramsArray.join("&");
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async getEventsSalesAnalytics(params) {
    let url = baseUrl + "events/sales/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.store && params.store.length > 0) {
        paramsArray.push(`stores=${params.store.join(",")}`);
      }
      if (params.event) {
        paramsArray.push(`event=${params.event}`);
      }
      url += paramsArray.join("&");
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async getIntegratedTransactionsAnalytics(params) {
    let url = baseUrl + "transactions/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.store && params.store.length > 0) {
        paramsArray.push(`stores=${params.store.join(",")}`);
      }
      if (params.tags && params.tags.length > 0) {
        paramsArray.push(
          `tags=${params.tags.map(x => x.replace("#", "")).join(",")}`
        );
      }
      if (params.start) {
        paramsArray.push(`start=${moment(params.start).format("YYYY-MM-DD")}`);
      }
      if (params.end) {
        paramsArray.push(`end=${moment(params.end).format("YYYY-MM-DD")}`);
      }
      if (params.category) {
        paramsArray.push(`category=${params.category}`);
      }
      if (params.grouped === true) {
        paramsArray.push(`grouped=true`);
      }
      if (params.product === true) {
        paramsArray.push(`product=true`);
      }
      url += paramsArray.join("&");
    }
    const res = await privateInstance.get(url);
    return res.data;
  },
  async getDefaultEvents() {
    let url = baseUrl + "events/defaults/";
    const res = await privateInstance.get(url);
    return res.data;
  },
  async getEvents() {
    let url = baseUrl + "events/";
    const res = await privateInstance.get(url);
    return res.data;
  },
  async retrieveEvent(id) {
    let url = baseUrl + `events/${id}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async postEvent(data) {
    let url = baseUrl + "events/";
    const res = await privateInstance.post(url, data);
    return res.data;
  },
  async updateEvent(id, data) {
    let url = baseUrl + `events/${id}/`;
    const res = await privateInstance.patch(url, data);
    return res.data;
  },
  async deleteEvent(id) {
    let url = baseUrl + `events/${id}/`;
    const res = await privateInstance.delete(url);
    return res.data;
  }
};
